import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=518f4ab2&scoped=true"
import script from "./Classify.vue?vue&type=script&lang=js"
export * from "./Classify.vue?vue&type=script&lang=js"
import style0 from "./Classify.vue?vue&type=style&index=0&id=518f4ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f4ab2",
  null
  
)

export default component.exports